module.exports = __webpack_public_path__ + "static/media/date-operation-icon.d3a490e4.svg";